import request from '../../axios';

export interface IPostLoanValidationPaymentPayload {
  loan_request: string;
}
export const postLoanValidationPayment = async (
  payload: IPostLoanValidationPaymentPayload,
) => {
  const {data} = await request.post(
    `/api/v2/payment/payment-loan-validation-request`,
    {
      ...payload,
    },
  );
  return data;
};
